export const CAPITAL_LETTERS_RECOGNITION_MESSAGES = {
  CORRECT: (letter: string) => `<correctly tapped ${letter}>`,
  INCORRECT: (letter: string) => `<incorrectly tapped ${letter}>`,
} as const;
